import FJTextImageInputContainer from '../container/FJTextImageInputContainer';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './FJObjectEraseText.module.less';
import FJObjectEraseTextPrompt from './FJObjectEraseTextPrompt';
import FJConstant from '../../../../constants/FJConstant';
import { useMemo } from 'react';
import { OBJECT_ERASE_USE_CREDIT } from '../../../../redux/slices/FJSliceObjectErase';
import FJGenerateButtonContainer from '../../../../common/combineComponents/FJGenerateButtonContainer/FJGenerateButtonContainer';
import useDefaultFreeLimit from '../../../../hooks/useDefaultFreeLimit.jsx';
import FJObjectEraseConfig from '../../../../config/appConfig/FJObjectEraseConfig.js';

const FJObjectEraseText = ({ disabled, taskStatus, isShow, textPrompt, onChangeTextPrompt }) => {
    const text = useMemo(() => {
        if (taskStatus === FJConstant.START) {
            return 'start';
        } else if (taskStatus === FJConstant.GENERATING) {
            return 'removing';
        }
        return 'remove';
    }, [taskStatus]);

    const defaultFreeNumCreation = useDefaultFreeLimit(FJObjectEraseConfig.promptRemovalFreeLimitType);

    return (
        <div className={classNames(styles.container, { [styles.show]: isShow })}>
            <FJTextImageInputContainer />
            <FJObjectEraseTextPrompt textPrompt={textPrompt} onChangeTextPrompt={onChangeTextPrompt} />

            <FJGenerateButtonContainer
                text={text}
                className={styles.generate_btn}
                useCredit={OBJECT_ERASE_USE_CREDIT}
                disabled={disabled}
                defaultFreeNumCreation={defaultFreeNumCreation}
            />
        </div>
    );
};

FJObjectEraseText.propTypes = {
    isNotImage: PropTypes.bool,
    disabled: PropTypes.bool,
    taskStatus: PropTypes.string,
    isShow: PropTypes.bool,
    textPrompt: PropTypes.string,
    onChangeTextPrompt: PropTypes.func,
};

export default FJObjectEraseText;
